import { Pause, Play } from 'lucide-react';
import { STEPS } from './storyScript';

/* The progress row under the stage.

   Owner 2026-09-30: ONE step at a time. The current step's name, bigger
   (18 px, 17 on phones), and under it one long bar that fills over that
   step in the step's own color (peach-gold, mint, sky, violet, coral) and
   starts again empty on the next step. The name eases in on each change.
   The pause button hangs to the right of the bar, off the centered axis, so
   the name and the bar share one center. The row keeps the old heights
   (52 px desktop, 62 phone: hero/layout.js PROGRESS), so nothing below moves.

   Reduced motion shows still posters and no loop, so there the five step
   buttons stay: they are the only way to see steps 2 to 5.

   The fill is written every frame by the engine (fillRefs), not by React;
   the bar's fill element is keyed by the step, so each step starts from a
   fresh, empty bar. The pause button carries its state in its label
   ("Pause the story" / "Play the story") and has no aria-pressed: a toggle
   whose label changes must not also be pressed (WAI-ARIA APG). */
function PauseButton({ togglePause, showPlay }) {
  return (
    <button type="button" className="cs-pause" onClick={togglePause} aria-controls="teacher-marketing-page" aria-label={showPlay ? 'Play animations' : 'Pause animations'}>
      <span className="cs-pause-ring" aria-hidden="true">
        {showPlay ? <Play strokeWidth={2.2} /> : <Pause strokeWidth={2.2} />}
      </span>
    </button>
  );
}

export default function StepRow({ engine, geo }) {
  const {
    index, jump, togglePause, showPlay, reduced, fillRefs,
  } = engine;
  const phone = geo.kind === 'phone';
  const style = { left: 0, right: 0, top: geo.progress.top };

  if (reduced) {
    return (
      <div className={`cs-progress${phone ? ' is-phone' : ''}`} style={style}>
        <span className="cs-progress-label" aria-live="polite">{STEPS[index].label}</span>
        <span className="cs-progress-ctl">
          <span className="cs-segs">
            {STEPS.map((s, i) => (
              <button
                key={s.id}
                type="button"
                className="cs-seg"
                aria-label={s.label}
                aria-current={i === index ? 'step' : undefined}
                aria-controls="cs-stage"
                onClick={() => jump(i)}
              >
                <span className="cs-seg-track" aria-hidden="true">
                  <span ref={(el) => { fillRefs.current[i] = el; }} className="cs-seg-fill" />
                </span>
              </button>
            ))}
          </span>
        </span>
      </div>
    );
  }

  return (
    <div className={`cs-progress cs-progress--one${phone ? ' is-phone' : ''}`} style={style}>
      <span className="cs-progress-label" aria-live="polite">
        <span key={index} className="cs-progress-name">{STEPS[index].label}</span>
      </span>
      <span className="cs-progress-ctl">
        <span className="cs-bar" data-step={index} aria-hidden="true">
          <span
            key={index}
            ref={(el) => {
              if (el) {
                fillRefs.current = [];
                fillRefs.current[index] = el;
              }
            }}
            className="cs-bar-fill"
          />
        </span>
        <PauseButton togglePause={togglePause} showPlay={showPlay} />
      </span>
    </div>
  );
}
